/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetAllOrders = (data: any) =>
  useQuery<any>({
    queryKey: [
      "GetAllOrders",
      data?.cashCenterId,
      data?.serviceType,
      data?.pageNumber,
      data?.pageRowCount,
      data?.searchCriteria,
      data?.operationDate,
      data?.customerId,
      data?.sourceSPId,
      data?.onwardSPId,
    ],
    queryFn: () => client(`daily/operations/all/orders`, { data }),
  });

export const useCreateOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/service`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetAllOrders"],
      });
    },
  });
};

export const useCreateBulkOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/service/bulk`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetAllOrders"],
      });
    },
  });
};
